// extracted by mini-css-extract-plugin
module.exports = {"blue_btn":"button_blue_btn__Y9fKf"};